export default class VideoHeroController {
    _isInitialized = false;
    _currentVideo = null;
    _heroVolume = null;
    _hero = null;
    _self = null;
    _timeOutToPlay = null;
    _timeOutToNext = null;
    _withInteraction = false;
    onEndedHandlerReference = null;
    onErrorHandlerReference = null;
    onPlayingHandlerReference = null;
    onCanPlayHandlerReference = null;
    _isWorking = false;
    _isDesktop = false;
    _standAlone = false;
    _videoObject = null;
    _trackingPlayingCallback = null;
    _trackingErrorCallback = null;
    _trackingEndedCallback = null;
    _trackingVolumeCallback = null;
    _staticSlideDuration = 10;  // duration of slides without video in seconds

    constructor(heroVolume, hero) {
        this._heroVolume = heroVolume;
        this._hero = hero;
        if (this._hero === null) {
            this._standAlone = true;
        }
        this._self = this;
        this.adjustVolumeButtonPosition();
        this.isMarquee =
            document.getElementsByClassName('swiper-pagination-bullets').length > 0 ? true : false;
        if (window.innerWidth > 1023) {
            if ( this.isMarquee) {
                this.initVideoMarquee();
            }
            this._isDesktop = true;
        }
        this.addVolumeEvents();
        this.addWindowResizeEvent();
        window.dispatchEvent(new Event('resize'));
    }

    playSplice(currentVideo) {
        this._videoObject = currentVideo;
        this._isWorking = true;
        $('#hero-slider .swiper-slide-active picture').show();
        
        if (this._currentVideo) {
            this.removeEvents();
        }
        
        if (currentVideo) {
            currentVideo = this.recreateVideo(currentVideo);
        }

        this._currentVideo = currentVideo;
        this.addEvents();

        // fix for some splice videos not playing if initial slide on marquee
        if($(currentVideo).attr('id') != 'marqueeVideo0'){
            clearTimeout(this._timeOutToPlay);
        }

        this._timeOutToPlay = setTimeout(() => {
            //this._currentVideo = currentVideo;
            if (this._currentVideo && this._isDesktop) {
                let heroPromise;
                try {
                    this._currentVideo.muted = true;
                    heroPromise = this._currentVideo.play();
                    $('.marqueeVideoContainer').removeClass('disabled');
                    this._heroVolume.removeClass('disabled');
                    if (localStorage.getItem('spliceVolumeOn') == 0) {
                        this.setMute();
                    }
                    this._heroVolume.show();
                } catch (e) {
                    console.log('Error returned in hero promise');
                }
                if (heroPromise !== undefined && this._isDesktop) {
                    heroPromise
                        .then(() => {
                            $('.marqueeVideoContainer').fadeIn(1200);
                            if (localStorage.getItem('spliceVolumeOn') == 0) {
                                this.setMute();
                            } else {
                                this.setMute();
                                this._currentVideo.play();
                            }
                        })
                        .catch((error) => {
                            // Auto-play muted splice
                            this.setMute();
                            this._currentVideo.play();
                            if (this._currentVideo.readyState) {
                                $('.marqueeVideoContainer').fadeIn(1200);
                            } else {
                                this.stopHero(false);
                            }
                        });
                } else {
                    this.stopHero(false);
                }
            } else {
                console.log('No video available.');
            }
        }, 3000);
    }
    
    recreateVideo($targetVideo) {
        let $parent = $targetVideo.parent();
        let sourceURL = $targetVideo.find('source:first').attr('src');
        let videoString = `<video>
                                <source src="${sourceURL}" type="video/mp4">
                                Your browser does not support the video tag.
                            </video>`;
        $parent.prepend(videoString);
        let $video = $parent.children().first();
        this._videoObject = $video;
        this.copyAttributes($targetVideo, $video);
        $targetVideo.remove();
        return $video[0];
    }

    copyAttributes($copyFrom, $copyTo) {
        var attrbts = $copyFrom.prop('attributes');

        $.each(attrbts, function () {
            $copyTo.attr(this.name, this.value);
        });
    }

    addWindowResizeEvent() {
        window.addEventListener(
            'resize',
            this.debounce((e) => {
                if (e.target.innerWidth > 1023) {
                    this._isDesktop = true;
                    if (this.isMarquee) {
                        this.resetVideoMarquee(this._isDesktop);
                        let slideVideo = $(this._currentVideo)
                        this.playSplice(slideVideo)
                    }
                    if (!this._isWorking) {
                        this.reset();
                    }
                } else {
                    this._isDesktop = false;
                    if (this.isMarquee) {
                        this.resetVideoMarquee(this._isDesktop);
                    }
                    if (this._isWorking) {
                        this._isWorking = false;
                        this.reset();
                    }
                }
            })
        );
    }

    addVolumeEvents() {
        this._heroVolume.show();
        this._heroVolume.on('click', (e) => {
            e.preventDefault();
            this.setMute(!this._heroVolume.hasClass('muted'), true);
        });
    }

    adjustVolumeButtonPosition() {
        // Change volume button positioning if this is a movie detail page
        if (document.getElementsByClassName('movie__meta-container').length > 0) {
            var volumePositionHelper = $('#volume-position-helper').offset().top;
            var metaOffset = $('.hero__content-slide-wrapper').offset().top;
            $('.hero-volume').css({top: volumePositionHelper - 435 - metaOffset + 'px'});
        }
    }

    debounce(func, timeout = 250) {
        let timer;
        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => {
                func.apply(this, args);
            }, timeout);
        };
    }

    stopHero(sw, withInteraction = false) {
        this._withInteraction = withInteraction;
        clearTimeout(this._timeOutToPlay);
        clearTimeout(this._timeOutToNext);
        if (!this._standAlone) {
            if (sw) {
                this._hero.autoplay.stop();
                try {
                    this._currentVideo.pause();
                } catch (e) {

                }
            } else {
                this._hero.autoplay.start();
            }
        }
        
    }

    initVideoMarquee() {
        this.stopHero(true);
        
        document.querySelectorAll('.marqueeVideo').forEach(item => {
            // Video already loaded or cached.
            // Get the index of this slide
            let index = parseInt(item.id.replace('marqueeVideo', ''));

            // Update the progress bar duration for this slide
            let bullet = this._hero.pagination.bullets[index];
            let el = $(bullet).find('b');

            if ((index === 0) && (item.readyState >= 4) && (!$('.main-overlay').is(':visible'))){
                try {
                    // Video has already loaded or is available in cache.
                    let videoSlide = $('.hero__content-wrapper .swiper-wrapper li:nth-child(' + (index + 1) + ')');
                    videoSlide.attr('data-swiper-autoplay', (item.duration + 4) * 1000);
    
                    el.css({
                        'animation-duration': (item.duration + 4) + 's'
                    });
                    el.css({
                        '-webkit-animation-duration': (item.duration + 4) + 's'
                    });
                    
                    this.stopHero(false);
                } catch (e) {

                } 

            } else {
                item.addEventListener('loadedmetadata', event => {
                    if (index > 0) {
                        // Set the progress bar to the length of the video + 3 sec before
                        el.css({
                            'animation-duration': (item.duration + 3) + 's'
                        });
                        el.css({
                            '-webkit-animation-duration': (item.duration + 3) + 's'
                        });
                    }

                    // Update the slide duration to the length of the video + 3 secs for poster display before video start
                    let videoSlide = $('.hero__content-wrapper .swiper-wrapper li:nth-child(' + (index + 1) + ')');
                    videoSlide.attr('data-swiper-autoplay', (item.duration + 3) * 1000);

                    if (index === 0 && (!$('.main-overlay').is(':visible'))) {
                        videoSlide.attr('data-swiper-autoplay', (item.duration + 4) * 1000);

                        el.css({
                            'animation-duration': (item.duration + 4) + 's'
                        });
                        el.css({
                            '-webkit-animation-duration': (item.duration + 4) + 's'
                        });
                        
                        this.stopHero(false);

                        // hack for first slide video issue. Jump to slide 2 and immediately back to slide 1 to make sure we
                        // have the correct slide duration value set prior to playing. Skip if an overlay is displayed.
                        this._hero.slideTo(1, 0, true);
                        this._hero.slideTo(0, 0, true);

                    }
                })
            }
        })
    }
    
    resetVideoMarquee(videoEnabled) {
        this._hero.autoplay.stop();
        if (videoEnabled) {
            // Update all slides with video to include time for splice video playback
            document.querySelectorAll('.marqueeVideo').forEach(item => {
                // Get the index of this slide
                let index = parseInt(item.id.replace('marqueeVideo', ''));

                // Update the progress bar duration for this slide
                let bullet = this._hero.pagination.bullets[index];
                let el = $(bullet).find('b');

                // Set the progress bar to the length of the video + 3 sec before 
                el.css({
                    'animation-duration': Math.round(item.duration + 3) + 's'
                });
                el.css({
                    '-webkit-animation-duration': Math.round(item.duration + 3) + 's'
                });

                // Update the slide duration to the length of the video + 3 secs for poster display before video start
                let videoSlide = $('.hero__content-wrapper .swiper-wrapper li:nth-child(' + (index + 1) + ')');
                let videoSlideDuration = (isNaN((item.duration + 3) * 1000)) ? this._staticSlideDuration * 1000 : (item.duration + 3) * 1000;  
                videoSlide.attr('data-swiper-autoplay', videoSlideDuration);
            })
        } else {
            // Set progress bar and slide to default static settings
            let videoBullets = document.querySelectorAll('.swiper-pagination-bullet b'), i;
            for (i= 0; i < videoBullets.length; ++i) {
                // reset CSS animation trick, clone element and replace old
                let el = videoBullets[i]
                let newEl = el.cloneNode(true)
                el.parentNode.replaceChild(newEl, el)
                // change to static slide duration when on mWeb
                $(newEl).css({
                    'animation-duration': this._staticSlideDuration + 's'
                });
                
                // TODO: remove -webkit-animation-duration from other functions (deprecated) 
            }
            $('.hero__content-slider .swiper-slide').attr('data-swiper-autoplay', this._staticSlideDuration  * 1000);
        }
        this._hero.autoplay.start();
    }

    addEvents() {
        if(this._currentVideo){
            this._currentVideo.addEventListener(
                'ended',
                (this.onEndedHandlerReference = (ev) => this.onEndedHandler(ev))
            );
            this._currentVideo.addEventListener(
                'error',
                (this.onErrorHandlerReference = (ev) => this.onErrorHandler(ev)),
                true
            );
            this._currentVideo.addEventListener(
                'playing',
                (this.onPlayingHandlerReference = (ev) => this.onPlayingHandler(ev))
            ); 
        }
    }

    removeEvents() {
        this._currentVideo.removeEventListener('ended', this.onEndedHandlerReference);
        this._currentVideo.removeEventListener('error', this.onErrorHandlerReference);
        this._currentVideo.removeEventListener('playing', this.onPlayingHandlerReference);
    }

    onPlayingHandler() {
        if (this._trackingPlayingCallback) {
            this._trackingPlayingCallback();
        }
    }

    onErrorHandler() {
        $('.marqueeVideoContainer').addClass('disabled');
        $('.marqueeVideoContainer').hide();
        $('.marqueeVideoContainer overlayContainer').hide();
        this.stopHero(false);

        if (this._trackingErrorCallback) {
            this._trackingErrorCallback();
        }
    }

    onEndedHandler() {
        if (this.isMarquee) {
            // Hide the marquee image to prevent it from briefly being visible during the transition to next slide
            $('#hero-slider .swiper-slide-active picture').hide();
        } else {
            $('.marqueeVideoContainer').fadeOut(400);
            $('.hero-volume').fadeOut(400);
        }
        
        clearTimeout(this._timeOutToNext);
        
        if (this._trackingEndedCallback) {
            this._trackingEndedCallback();
        }
    }

    isPlaying(video) {
        return (
            video.currentTime > 0 &&
            !video.paused &&
            !video.ended &&
            video.readyState > video.HAVE_CURRENT_DATA
        );
    }

    setMute(sw = true, callTracking = false) {
        let trackAction = null;
        if(this._currentVideo) {
            this._currentVideo.muted = sw;
        }
        if (sw) {
            this._heroVolume.addClass('muted').attr('title','Unmute Audio');
            localStorage.setItem('spliceVolumeOn', 0);
            trackAction = 'trackMutePlayer';
        } else {
            this._heroVolume.removeClass('muted').attr('title','Mute Audio');
            localStorage.setItem('spliceVolumeOn', 1);
            trackAction = 'trackUnmutePlayer';
        }
        if (callTracking) {
            if (this._trackingVolumeCallback) {
                this._trackingVolumeCallback(trackAction);
            }
        }
        
    }

    reset() {
        try {
            if (this.isPlaying(this._currentVideo)) {
                this._currentVideo.currentTime = 0;
                this._currentVideo.pause();
                this.removeEvents();
            }
        } catch (e) {}

        $('.marqueeVideoContainer').fadeOut(0);

        $('.swiper-pagination-bullet b').each(function () {
            //$(this).removeAttr('style');
        });
        this.stopHero(false);

        clearTimeout(this._timeOutToPlay);
        clearTimeout(this._timeOutToNext);
    }

    set trackingPlayingCallback(val) {
        this._trackingPlayingCallback = val;
    }

    set trackingErrorCallback(val) {
        this._trackingErrorCallback = val;
    }

    set trackingEndedCallback(val) {
        this._trackingEndedCallback = val;
    }
    
    set trackingVolumeCallback(val) {
        this._trackingVolumeCallback = val;
    }
}
